import { FlexAligner, ErrorBlock } from "src/components";
import styling from "./ErrorPage.module.scss";

export const ErrorPage = () => {
	return (
		<FlexAligner width="viewport" height="viewport" alignment="center" className={styling["wrapper"]}>
			<ErrorBlock />
		</FlexAligner>
	);
};
